import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigServerService, CustomHttp } from '../../../../core';
import { IAtividadeFiltro } from '../interfaces/atividade-filtro.interface';

@Injectable({ providedIn: 'root' })
export class AtividadeRelatorioApi {
  constructor(
    private customHttp: CustomHttp,
    private configServerService: ConfigServerService,
  ) {}

  imprimir(filtro: IAtividadeFiltro): Observable<Blob> {
    const url = `${this.configServerService.getPathApiPrint()}/atividade/impressao`;
    return this.customHttp.post<Blob>(url, filtro, { responseType: 'blob' });
  }
}
